import { ThemeProvider } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { Prompt } from 'react-router-dom';
import { Wizard } from './components/Wizard.component';
import { themedStyles } from './themedStyles';
import ReactGA from 'react-ga';
import { ping } from './apis/apis';
import { MessageAlert } from './components/alerts/MessageAlert.component';
import { externalRoutes } from './routing/routing';
import { InfoPage } from './pages/InfoPage';
import { MaintenanceAlert } from './pages/MaintenancePage';

export const TeacherVoiceGame = () => {
    const [isPrompt, setIsPrompt] = useState(false);
    const [showMessageAlert, setShowMessageAlert] = useState(false);
    const [showWizard, setShowWizard] = useState(false);

    // Prevent leaving page Reference: https://javascript.plainenglish.io/how-to-alert-a-user-before-leaving-a-page-in-react-a2858104ca94
    useEffect(() => {
        ReactGA.pageview('TeacherVoice: First page of teacher voice game');

        window.addEventListener('beforeunload', handleLeavingSite);
        window.addEventListener('unload', handleLeavingGame);

        async function checkServerIsWorking() {
            try {
                await ping();
            } catch (e) {
                setShowMessageAlert(true);
            }
        }

        checkServerIsWorking();

        return () => {
            window.removeEventListener('beforeunload', handleLeavingSite);
            window.removeEventListener('unload', handleLeavingGame);
            handleLeavingGame();
        };
    }, []);

    const handleLeavingSite = (e: any) => {
        e.preventDefault();
        e.returnValue = '';
    };

    const handleLeavingGame = async () => {
        setIsPrompt(true);
    };

    const goHome = useCallback(() => {
        window.location.href = externalRoutes.home;
    }, []);

    return (
        <ThemeProvider theme={themedStyles}>
            <Prompt
                when={true}
                message={() =>
                    'Are you sure you want to leave this page? You will not be able to go back.'
                }
            />
            <MessageAlert
                open={showMessageAlert}
                setOpen={setShowMessageAlert}
                message={
                    'Unfortunately, this activity is down right now. Please try again later and checkout the other activities in the meantime.'
                }
                title={'Something went wrong'}
                cta={goHome}
                buttonTitle={'Go Home'}
            />
            {showWizard ? (
                <Wizard showInfoPage={() => setShowWizard(false)} />
            ) : (
                <InfoPage handleStart={() => setShowWizard(true)} />
            )}
        </ThemeProvider>
    );
};
